import { useIntl } from 'react-intl';

import { BasicInfo } from '@/src/listings/types';
import { getAttendeeTimezone, getDisplayTimezone, getEventDateTimeDisplayString } from '@/src/listings/utils/dateTime';
import { MULTIPLE_DATES } from '@/src/listings/components/_shared/constants';

export const useEventTitle = (basicInfo: BasicInfo | undefined, locale: string = 'en') => {
  const { formatMessage } = useIntl();

  if (!basicInfo) {
    return 'Eventbrite';
  }
  const { name, venue, startDate, endDate, hideStartDate, hideEndDate, isOnline, isSeries } = basicInfo;

  const eventCity = venue?.address?.city ? `, ${venue.address.city}` : '';

  let dateTimeCity = eventCity;
  if (startDate?.utc) {
    const attendeeTimezone = getAttendeeTimezone();
    const timezone = getDisplayTimezone({
      isOnlineEvent: isOnline ?? false,
      eventTimezone: startDate.timezone,
      attendeeTimezone,
    });
    const displayString = getEventDateTimeDisplayString({
      startDate,
      endDate: endDate ?? { utc: null, timezone: null },
      hideStartDate: hideStartDate ?? false,
      hideEndDate: hideEndDate ?? false,
      locale,
      timezone,
      formatMessage,
      isRecurringEvent: isSeries ?? false,
      recurringEventLabel: isSeries ? formatMessage(MULTIPLE_DATES) : undefined,
      showTimezone: isOnline ?? false,
    });
    if (displayString) {
      dateTimeCity = `, ${displayString}`;
    }
  }

  const ticketHeader = formatMessage({ id: 'Tickets' });

  const title = `${name} ${ticketHeader}${dateTimeCity} | Eventbrite`;

  return title;
};
